<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import { required } from "vuelidate/lib/validators";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import Swal from "sweetalert2";
import { sendNotification } from "@/utils/helpers/notification"
import CheckModal from "@/components/CheckModal"
import ItemAPI from "@/services/items/itemsAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI"
import evaluacionImpactoAPI from "../../../services/standards/evaluacionImpacto/evaluacionImpactoAPI";
/**
 * Form elements component
 */
export default {
  page: {
    title: "Evaluación del impacto de cambios internos y externos en el SG SST",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
  },
  data() {

    return {
      title: "2.11.1-1 Gestión del cambio",
      items: [

        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Gestión del cambio",
        },
        {
          text: "Editar",
          active: true,
        },
      ],

      lista: [],
      loading: true,
      evaluation_id: null,

      itemData: null,

      item: null,

      itemData: null,
      deleteCount: 0,
      file: null,

      evaluacionImpacto: {
        type_change: null,
        description: null,
        file: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      gestionCambio: {
        file: null,
        evaluation_impacts_id: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      submitted: false,
      nit: this.$store.getters["company/getCompany"].nit || null,
      company: this.$store.getters["company/getCompany"] || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,

    };
  },

  validations: {
    file: {
      required,
    },
  },
  methods: {

    getItemData() {
      ItemAPI.getItems(22)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    fetch() {
      this.$refs.paginator.query();
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 22)
        .then(response => {
          this.item = response || null
        })
        .catch(error => {
          console.log(error)
        })
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },

    /**
    * This method is used to knows if the user has the permission indicated
    * @param {String} name The name of the permission
    * @param {Array} roles the roles that permitted to access the action 
    * @returns {Boolean} true if the user has the permission indicated or false if no
    */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions
        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    /**
   * This method is used to redirect to the page indicated
   * @param {String} page The page to redirect
   */
    goPage(page) {
      window.location.href = page
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        let name = '';

        if (this.file === null) {
          name = this.getFile(this.gestionCambio.file)
        } else {
          name = this.file.name
        }

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/2.11.1/${this.evaluation_id}/evaluacion_impacto/${this.$route.params.id}/${name}`;
        } else {
          url = `sst-prod/${this.nit}/2.11.1/${this.evaluation_id}/evaluacion_impacto/${this.$route.params.id}/${name}`;
        }

        if (this.file === null) {
          return true;
        } else {
          const result = await uploadDocument(url, this.file);
          if (result) {
            this.gestionCambio.file = `${process.env.VUE_APP_BUCKET}/${url}`;
            return true;
          } else return false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async save() {
      this.submitted = true;
      this.loading = true
      let response = await this.uploadDocument();
      if (response) {
        evaluacionImpactoAPI.updateG(this.$route.params.id, this.gestionCambio)
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 22,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.sendNotification(56, 22, true)
                this.loading = true
                setTimeout(() => {
                  Swal.fire({
                    title: "Éxito!",
                    text: "Informacion actualizada con éxito!",
                    icon: "success",
                    type: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  this.$router.go(-1);
                }, 1500)
              })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
            this.loading = false
          });
      } else {
        this.loading = false
        setTimeout(() => {
          Swal.fire({
            title: "¡Error!",
            text: "¡No se ha podido registrar!",
            icon: "warning",
            type: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        }, 2000)
      }
    },

    getShow() {
      evaluacionImpactoAPI
        .getShowG(this.$route.params.id)
        .then((response) => {
          this.loading = false
          this.evaluation_id = response.data.id
          this.gestionCambio = {
            type_change: response.data.type_change,
            file: response.data.mei_file,
            description: response.data.description,
            companies_id: response.data.companies_id,
            evaluation_impacts_id: response.data.id
          };
          this.evaluacionImpacto = {
            type_change: response.data.type_change,
            file: response.data.file,
            description: response.data.description,
            companies_id: response.data.companies_id,
          };
          if (Array.isArray(this.evaluacionImpacto)) {
            this.deleteCount = this.evaluacionImpacto.length;
          } else {
            this.deleteCount = 0;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    getFile(file) {
      const name = file.split('/')
      return name[name.length - 1]
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

  },

  mounted() {
    this.getItems();
    this.getItemData();
    this.getShow();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">

              <div class="row px-3">
                <div class="col-12 text-right m-b-0">
                  <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="back" placement="left"> Volver </b-tooltip>
                </div>
              </div>
              <hr />

              <form class="form-group" @submit.prevent="save">
                <div class="form-row pt-3 ml-3">

                  <b-form-group label-for="employee" class="col-md-6 px-2 mb-3" label="Tipo de cambio">
                    <h5>{{ evaluacionImpacto.type_change }}</h5>

                  </b-form-group>

                  <b-form-group class="col-md-6 px-2 mb-3" label="Subir evidencia" label-for="file">
                    <b-form-file :disabled="!getRole('Crear') || !allowAccess()" type="file" id="file" ref="file"
                      name="file" browse-text="Buscar"
                      :placeholder="gestionCambio.file ? getFile(gestionCambio.file) : `Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile">
                    </b-form-file>
                    <div v-if="submitted && $v.file.$error">
                      <small v-if="!$v.file.required" class="text-danger">
                        <b>La evidencia es requerida</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-md-12 px-2" label="Breve descripción del cambio a realizar"
                    label-for="trainingDate">
                    <h5>{{ evaluacionImpacto.description }}</h5>

                  </b-form-group>

                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="!getRole('Crear') || !allowAccess()" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>

              </form>
            </div>
          </div>

        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>